import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuth";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const { user, login } = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Invalid credentials.";
      toast.error(typeof msg === "string" ? msg : "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-[#f5f0e8] text-[#1c1c1c] grain flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-12">
          <Logo size="lg" />
        </div>

        <div className="border border-[#1c1c1c]/12 bg-white/80 backdrop-blur-xl p-10">
          <div className="underline-label mb-4">Private Console</div>
          <h1 className="font-display text-3xl mb-10 text-[#1c1c1c]">Sign in</h1>

          <form onSubmit={submit} className="space-y-8">
            <div>
              <label className="underline-label mb-3 block text-[#6a6259]">Email</label>
              <input
                data-testid="admin-login-email"
                type="email"
                className="editorial-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                required
              />
            </div>
            <div>
              <label className="underline-label mb-3 block text-[#6a6259]">Password</label>
              <input
                data-testid="admin-login-password"
                type="password"
                className="editorial-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={busy}
              className="w-full py-4 bg-[#c5a059] text-black uppercase text-[11px] tracking-[0.32em] hover:bg-[#1c1c1c] hover:text-[#f5f0e8] transition-colors disabled:opacity-60"
            >
              {busy ? "Signing in…" : "Enter Console"}
            </button>
          </form>
        </div>

        <p className="text-center text-[10px] uppercase tracking-[0.32em] text-[#6a6259] mt-8">
          AZEFAC Properties · Restricted Access
        </p>
      </div>
    </main>
  );
}
